import React from "react"
import { IMedia, EventCallback } from "../interfaces"

interface Props {
  media: IMedia
  loading?: "lazy" | "eager"
  onLoad?: EventCallback
}

class MediaImg extends React.Component<Props> {
  constructor(props) {
    super(props)

    this.handleOnLoad = this.handleOnLoad.bind(this)
  }

  handleOnLoad(event) {
    if (this.props.onLoad != null) {
      this.props.onLoad(event)
    }
  }

  render() {
    const { media, loading } = this.props
    if (media.data == null) return <div></div>
    const {
      className,
      id,
      name,
      alternativeText,
      caption,
      width,
      height,
      hash,
      ext,
      mime,
      size,
      url,
      dataSrc,
      previewUrl
    }: IMedia = media

    if (url == null) return <div></div>
    return (
      <>
        <img
          data-src={dataSrc ? url : null}
          src={!dataSrc ? url : null}
          loading={loading}
          alt={alternativeText}
          onLoad={this.handleOnLoad}
          className={className}
        />
      </>
    )
  }
}

export default MediaImg
